<div class="flex flex-col justify-center toolbar">
  <div class="max-width-lg">
    <div class="flex flex-row flex-auto justify-between items-center w-100-percent ml--24">
      <div class="flex flex-row justify-center items-center">
        <mat-icon *ngIf="!authService?.hideToolbar && authorities" svgIcon="menu" class="icon-lg cursor-pointer" [matMenuTriggerFor]="hamburgerMenu"></mat-icon>
        <img src="assets/images/temenos-banking-cloud-logo-new.png" class="logo ml-10" [routerLink]="authorities ? ['/', tenant] : null">
        <mat-menu #hamburgerMenu [xPosition]="'before'" class="hamburger-menu">
          <div class="flex flex-col">
            <button class="btn-menu-link mr-8 ml-8"
                    [routerLink]="['/', tenant]"
                    [ngClass]="{'active': ToolbarButton.HOME === activeLink}">
              <div class="flex flex-row items-center">
                <mat-icon svgIcon="home" class="icon-md mr-16"></mat-icon>
                <div class="mat-body hamburger-menu-item">{{ 'TOOLBAR.HOME_DASHBOARD' | transloco }}</div>
              </div>
            </button>
            <!-- <button class="btn-menu-link mr-24 ml-24 mt-8"
                    [routerLink]="['/', tenant, RouterSegments.CATALOGUE]"
                    [ngClass]="{'active': ToolbarButton.CATALOGUE === activeLink}">
              <div class="flex flex-row items-center">
                <mat-icon svgIcon="inbox" class="icon-md mr-16"></mat-icon>
                <div class="mat-body hamburger-menu-item">{{ 'TOOLBAR.CATALOGUE' | transloco }}</div>
              </div>
            </button> -->
            <!-- <button class="btn-menu-link mr-16 ml-16"
                    [routerLink]="['/', tenant, RouterSegments.MY_SERVICES]"
                    [ngClass]="{'active': ToolbarButton.MY_SERVICES === activeLink}">
              <div class="flex flex-row items-center">
                <mat-icon svgIcon="work_outline" class="icon-md mr-16"></mat-icon>
                <div class="mat-body hamburger-menu-item">{{ 'TOOLBAR.MY_SERVICES' | transloco }}</div>
              </div>
            </button> -->
            <!-- <button class="btn-menu-link mr-24 ml-24 mt-8 mb-8"
                    [routerLink]="['/', tenant, RouterSegments.INSPIRATION_LOUNGE]"
                    [ngClass]="{'active': ToolbarButton.INSPIRATION_LOUNGE === activeLink}">
              <div class="flex flex-row items-center">
                <mat-icon svgIcon="control_camera" class="icon-md mr-16"></mat-icon>
                <div class="mat-body hamburger-menu-item">{{ 'TOOLBAR.INSPIRATION_LOUNGE' | transloco }}</div>
              </div>
            </button>
            <button *ngIf="permissionsMap[Permission.DOWNLOAD_IAC]" class="btn-menu-link mr-24 ml-24 mt-8 mb-8" [routerLink]="['/', tenant, RouterSegments.DOWNLOADS]"
              [ngClass]="{'active': ToolbarButton.DOWNLOAD_IAC === activeLink}">
              <div class="flex flex-row items-center">
                <mat-icon svgIcon="download_for_offline" class="icon-md mr-16"></mat-icon>
                <div class="mat-body hamburger-menu-item">{{ 'TOOLBAR.DOWNLOAD' | transloco }}</div>
              </div>
            </button> -->
            <!-- We can enable audit trail menu once the show data issue fixed -->
            <!-- <button class="btn-menu-link mr-24 ml-24 mt-8 mb-8"
                    [routerLink]="['/', tenant, RouterSegments.AUDIT_TRAIL]"
                    [ngClass]="{'active': ToolbarButton.AUDIT_TRAIL === activeLink}">
              <div class="flex flex-row items-center">
                <mat-icon svgIcon="language" class="icon-md mr-16"></mat-icon>
                <div class="mat-body hamburger-menu-item">{{ 'TOOLBAR.AUDIT_TRAIL' | transloco }}</div>
              </div>
            </button> -->
            <!--Below menu item is hidden for now, shall be added back later-->
            <!--<button class="btn-menu-link mr-24 ml-24 mt-8 mb-8"
                    [routerLink]="['/', tenant, RouterSegments.RESOURCES]"
                    [ngClass]="{'active': ToolbarButton.RESOURCES === activeLink}" disabled>
              <div class="flex flex-row items-center">
                <mat-icon svgIcon="import_contacts" class="icon-md mr-16"></mat-icon>
                <div class="mat-body hamburger-menu-item">{{ 'TOOLBAR.RESOURCES' | transloco }}</div>
              </div>
            </button>-->
          </div>
        </mat-menu>
      </div>
      <div class="flex flex-row justify-center items-center">
        <button class="rounded accent mr-14 hidden" type="button"
                *ngIf="hasMySandboxPermission"
                [disabled]="!permissionsMap[Permission.UPGRADE_ENTERPRISE]"
                (click)="openPlanModal()">{{ 'TOOLBAR.UNLOCK_ENTERPRISE' | transloco }}</button>
        <!-- <app-search-filter></app-search-filter> -->
        <!-- <mat-icon class="mr-24 ml-24 cursor-pointer fs-12"
                  [matBadge]="notificationsService.unreadNotificationsCount > 0 ? (notificationsService.unreadNotificationsCount > 99 ? '99+' : notificationsService.unreadNotificationsCount) : null"
                  matBadgeColor="warn" matBadgeSize="small" [ngClass]="{'stretch-badge' : notificationsService.unreadNotificationsCount > 99}">
          <mat-icon svgIcon="notifications" (click)="openNotificationsModal()"></mat-icon>
        </mat-icon> -->
        <app-user-menu></app-user-menu>
      </div>
    </div>
  </div>
</div>
